import {Middleware} from '@reduxjs/toolkit'
import {LOCATION_CHANGE} from 'redux-first-history'

import {makeReplaceName} from '@shared/helpers/format'

import {ROUTER_ORDER_SALE_HISTORY} from '@web/core/routes'
import {Sentry} from '@web/helpers/log'

const orderNo = '[0-9]{16}'
const productOrderNo = '[0-9]{16}'
const getTransactionName = makeReplaceName([
    [
        `${ROUTER_ORDER_SALE_HISTORY.CANCEL_REJECT}/${orderNo}/product/${productOrderNo}`,
        `${ROUTER_ORDER_SALE_HISTORY.CANCEL_REJECT}/{orderNo}/product/{productOrderNo}`,
    ],
    [
        `${ROUTER_ORDER_SALE_HISTORY.CANCEL_SALE}/${orderNo}/product/${productOrderNo}`,
        `${ROUTER_ORDER_SALE_HISTORY.CANCEL_SALE}/{orderNo}/product/{productOrderNo}`,
    ],
    [
        `${ROUTER_ORDER_SALE_HISTORY.DELIVERY_DISPATCH}/${orderNo}/product/${productOrderNo}`,
        `${ROUTER_ORDER_SALE_HISTORY.DELIVERY_DISPATCH}/{orderNo}/product/{productOrderNo}`,
    ],
    [
        `${ROUTER_ORDER_SALE_HISTORY.RETURN_ADMISSION}/${orderNo}/product/${productOrderNo}`,
        `${ROUTER_ORDER_SALE_HISTORY.RETURN_ADMISSION}/{orderNo}/product/{productOrderNo}`,
    ],
    [
        `${ROUTER_ORDER_SALE_HISTORY.RETURN_REJECT}/${orderNo}/product/${productOrderNo}`,
        `${ROUTER_ORDER_SALE_HISTORY.RETURN_REJECT}/{orderNo}/product/{productOrderNo}`,
    ],
    [`${ROUTER_ORDER_SALE_HISTORY.DETAIL}/${orderNo}`, `${ROUTER_ORDER_SALE_HISTORY.DETAIL}/{orderNo}`],
])

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sentryTransaction: Middleware = () => (next) => (action: any) => {
    next(action)

    if (action.type === LOCATION_CHANGE) {
        Sentry.setTransactionName(getTransactionName(window.location.pathname))
    }
}

export default sentryTransaction
